import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { ActionButton } from '../ActionButton';
import styles from './styles.module.scss';

interface ConfirmModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  btitle: string;
  description: string;
  action: () => void;
  'data-testid'?: string;
}
export default function ConfirmModal({
  show,
  onClose,
  title,
  btitle,
  description,
  action,
  'data-testid': dataTestId,
}: ConfirmModalProps) {
  const [showStatus, setShowStatus] = useState(show);
  const rootRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
    function handleClick(e: MouseEvent) {
      if (rootRef && rootRef.current && contentRef && contentRef.current) {
        const root = rootRef.current;
        const content = contentRef.current;
        if (root.contains(e.target as Node) && !content.contains(e.target as Node)) {
          onClose();
        }
      }
    }
  }, [show]);

  useEffect(() => {
    setShowStatus(show);
  }, [show]);

  return (
    <>
      <div
        className={showStatus ? styles.loaderWrapper : styles.displayNone}
        ref={rootRef}
        data-testid={dataTestId}
      >
        <div className={styles.modalRoot} ref={contentRef}>
          <div className={styles.title}>{title}</div>
          <div className={styles.mainContainer}>
            <div className={clsx(styles.descContainer)}>
              {description.split('\n').map((str, index) => (
                <React.Fragment key={index}>
                  {str}
                  <br />
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className={styles.btnContainer}>
            <ActionButton
              content='キャンセル'
              className={styles.cancelBtn}
              action={onClose}
              data-testid='confirm-modal-cancel'
            />
            <ActionButton
              content={btitle}
              type='dark'
              className={styles.confirmBtn}
              action={action}
              data-testid='confirm-modal-action'
            />
          </div>
        </div>
      </div>
    </>
  );
}
